export default __webpack_public_path__ + "static/qr-code-2f5fdd834a4fec54c6772adbba6df585.png";